import React, { Suspense, useEffect, useState } from "react";
import CookieService from "../services/CookieService";
import { appConfig } from "../config/config";
import { useNavigate } from "react-router-dom";

import { UserApi } from "../services/users";
import { useAppDispatch } from "../store/hooks";
import { verify } from "../store/reducers/auth/verify";
import appRoutePath from "../config/path";

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);
  useEffect(() => {
    const validateTokenAndFetchProfile = async () => {
      const token = CookieService.getCookie(appConfig.authAccessToken);
      if (!token) {
        setIsAuthorized(false);
        navigate(appRoutePath.AUTH_PAGE);
        return;
      }

      try {
        const response = await UserApi.getUserProfile();
        if (response?.data) {
          dispatch(verify(response.data));
          setIsAuthorized(true);
        } else {
          setIsAuthorized(false);
          navigate(appRoutePath.AUTH_PAGE);
        }
      } catch (error) {

        setIsAuthorized(false);
        navigate(appRoutePath.AUTH_PAGE);
      }
    };

    validateTokenAndFetchProfile();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  if (isAuthorized === null) {
    return null;
  }

  return <Suspense fallback={<></>}>{children}</Suspense>;
};
